import {Scene} from "phaser";
import {PurchaseItemPanel} from "@/scenes.ui/purchase-item-panel";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export default class PackUtils {

    public static readonly GOLD_SUM = 180000;
    public static readonly PLATINUM_SUM = 250000;

    public static getMythDiscount(gemsCount: number) {
        if (gemsCount == PackUtils.GOLD_SUM) {
            return 25;
        } else if (gemsCount == PackUtils.PLATINUM_SUM) {
            return 50;
        } else if (gemsCount >= PackUtils.PLATINUM_SUM) {
            return 80;
        }
        return 0;
    }

    public static visualizeTake(scene: Scene, cps: PurchaseItemPanel[], sound: BaseSound) {
        let i = 0;
        for (let cp of cps) {

            let copy = new PurchaseItemPanel(cp.scene, cp.x / CU.S, cp.y / CU.S, cp.getDecorationId(), cp.getPi(), cp.getHeroDescCallback);
            SpriteUtils.scale(copy, cp.scaleX / CU.S / CU.S, cp.scaleY / CU.S / CU.S);
            copy.alpha = 0.5;
            cp.parentContainer.add(copy);

            let parX = cp.parentContainer.parentContainer.parentContainer.x + cp.parentContainer.parentContainer.x + cp.parentContainer.x + cp.x;
            let parY = cp.parentContainer.parentContainer.parentContainer.y + cp.parentContainer.parentContainer.y + cp.parentContainer.y + cp.y;
            cp.parentContainer.remove(cp);
            cp.setDepth(5000);
            cp.x = parX;
            cp.y = parY;
            scene.tweens.add({
                targets: cp,
                delay: 250 * i,
                duration: 2600,
                paused: true,
                props: {
                    x: {value: cp.x + [150, 200, 50, 175, 25][i], ease: 'Quint.easeOut'},
                    y: {value: cp.y + [700, 600, 800, 750, 725][i], ease: 'Linear'},
                    alpha: 0,
                    scale: 0.3
                },
                onStart: function () {
                    SoundUtils.play(sound);
                },
            }).play();
            ++i;
        }
    }
}
